import React, { Component, Fragment } from 'react';
import { Dialog, TableHead, DialogTitle, DialogContent, Typography, IconButton, Grid, Divider, Table, TableBody, TableRow, TableCell } from '@mui/material';
import Currency from '../../common/Currency';
import { ArrowBack } from '@mui/icons-material';
import { isEmpty } from "lodash"
import { extension } from 'mime-types'
import SpendingDetails from '../../Spendings/SpendingDetails';
import { orderByDateAsc, orderByDateDsc } from '../../../store/actions/format';

class AdvanceDetails extends Component {
    state = { 
        payments: [],
        openSpending: false,
        spending: {},
        fetched: false,
        payments: []
    }

    // ADVANCE => PAYMENTS => PAYMENT_DETAILS => SPENDING
    findPayments = () => {
        const { PAYMENT_DETAILS, PAYMENTS, SPENDINGS, CATEGORIES, ADVANCE_RETURNS, advance } = this.props;
        let payments = []

        let list = Object.values(PAYMENTS).filter( pay => pay.payment_supplier_advance === advance.advance_id && !pay.is_supplier_advance)
        list.forEach( pay => {
            Object.values(PAYMENT_DETAILS).forEach( item => {
                if (item.payment_info_id === pay.payment_id){
                    let spending =  SPENDINGS[item.payment_spending_id]
                    let category =  CATEGORIES.CHILD[spending.spending_category]
                    let categoryParent =  CATEGORIES.PARENT[category.category_parent].category_name
                    item.date = spending.spending_date
                    let payDetail = Object.assign({spending, category, categoryParent}, item)
                    payments.push(payDetail)
                }
            })
        })
        let aReturns = Object.values(ADVANCE_RETURNS).filter( deb => deb.advance_src === advance.advance_id)
        aReturns.forEach( aReturn => {
            payments.push({
                payment_info_id: aReturn.advance_id,
                payment_details_supplier: aReturn.advance_supplier,
                payment_amount: aReturn.advance_amount,
                payment_details_advance: aReturn.advance_src,
                // payment_is_supplier_advance:false,
                // payment_details_supplier:"",
                // payment_details_advance:"",
                date: aReturn.advance_date,
                payment_details_bank: aReturn.advance_bank,
                payment_details_mode: aReturn.advance_payment_mode,
                payment_details_ref: aReturn.advance_ref,
                type:"aReturn",
            })
        })
        
        payments = orderByDateAsc(payments, "date")

        console.log('====================================');
        console.log({payments});
        console.log('====================================');
        this.setState({
            fetched: true,
            payments
        })
    }

    render() {
        const { advance, SUPPLIERS, BANKS, PAYMENT_DETAILS, SPENDINGS, LABELS, PAYMENTS, CATEGORIES } = this.props
        const { payments, openSpending, spending, fetched } = this.state;

        // if ( !isEmpty(PAYMENT_DETAILS) && !isEmpty(SPENDINGS) && isEmpty(payments) ) {
        if (  !fetched && !isEmpty(PAYMENT_DETAILS) && !isEmpty(SPENDINGS)) {
            this.findPayments()
        }
        return (
            <Dialog
                // disableBackdropClick
                open={true}
                // onClose={this.props.handleClose}
                onClose={(_, reason) => {reason !== "backdropClick" && this.props.handleClose()} }
                aria-labelledby="form-dialog-title"
                maxWidth="lg"
                fullWidth
                scroll="paper"
            >
                {openSpending && spending && 
                    <SpendingDetails 
                        supplier={SUPPLIERS && SUPPLIERS[spending.spending_supplier]} 
                        LABELS={LABELS}
                        BANKS={BANKS}
                        PAYMENTS={PAYMENTS}
                        category={CATEGORIES.CHILD && CATEGORIES.CHILD[spending.spending_category]} 
                        spending={spending} 
                        view="ADMIN"
                        handleClose={()=> this.setState({ openSpending: false, spending: {} })}
                        fetchSpendingPayments={this.props.fetchSpendingPayments}
                    />
                }
                <DialogTitle >
                    <IconButton color="inherit" onClick={this.props.handleClose} aria-label="Close">
                        <ArrowBack /> 
                    </IconButton>
                    Advance n° {advance.advance_ref}
                </DialogTitle>
                <Divider />
                <DialogContent>
                    {/* <Typography variant="h6" style={{textAlign: "center"}}><Currency value={advance.advance_amount} /></Typography>
                    <Divider /> */}
                    <Grid container spacing={2} style={{marginTop: "20px"}}>
                        <Grid item xs={12} sm={6}>
                            
                            <Table className="table">
                                <TableBody>
                                    <TableRow>
                                        <TableCell> 
                                            <Typography variant="button">Montant</Typography></TableCell>
                                        <TableCell><Currency value={advance.advance_amount} /></TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell> 
                                            <Typography variant="button">Restant</Typography></TableCell>
                                        <TableCell><Currency value={advance.advance_total_available} /></TableCell>
                                    </TableRow>
                                    
                                    <TableRow>
                                        <TableCell> 
                                            <Typography variant="button">Utilisateur</Typography>
                                        </TableCell>
                                        <TableCell>{advance.advance_supplier_id && SUPPLIERS[advance.advance_supplier_id].supplier_name}</TableCell>
                                    </TableRow>
                                    
                                    <TableRow>
                                        <TableCell> 
                                            <Typography variant="button">Payé le:</Typography>
                                        </TableCell>
                                        <TableCell>{new Date(advance.advance_date).toLocaleDateString("fr-FR")}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell> 
                                            <Typography variant="button">Banque</Typography>
                                        </TableCell>
                                        <TableCell>
                                            {advance.advance_bank && BANKS[advance.advance_bank].bank_name}
                                        </TableCell>
                                    </TableRow>
                                    
                                    
                                </TableBody>
                            </Table>
                            
                        </Grid>
                        <Grid item xs={12} sm={6} >
                            {advance.advance_files &&
                                <Grid container spacing={3}>
                                    {advance.advance_files.map( (photo, index) => (
                                        <Fragment>
                                            {photo.filetype === "application/pdf" &&
                                                <Grid key={photo.filename} item xs={12} >
                                                    <a href={`/photos/${photo.filename}`} 
                                                        download={`fichier${index + 1}.${ extension(photo.filetype) || "pdf"}`}
                                                    >
                                                        <embed 
                                                            src={`/photos/single/${photo.filename}`} 
                                                            width="100%" 
                                                            height="400px" 
                                                            title={`fichier${index + 1}`} 
                                                            type="application/pdf"
                                                        />
                                                    </a>
                                                </Grid>
                                            }

                                            {photo.filetype !== "application/pdf" &&
                                                <Grid key={photo.filename} item xs={6} >
                                                    <a href={`/photos/${photo.filename}`} 
                                                        download={`fichier${index + 1}.${ extension(photo.filetype) || "pdf"}`}
                                                    >
                                                        <img 
                                                            src={`/photos/single/${photo.filename}`} 
                                                            title={`fichier${index + 1}`} 
                                                            alt={`fichier${index + 1}`} 
                                                        />
                                                    </a>
                                                </Grid>
                                            }
                                        </Fragment>                          
                                        )) }
                                </Grid>
                            }
                

                        </Grid>
                        
                    </Grid>
                    <Divider />
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell colSpan={3} style={{textAlign: "center", fontWeight: "700"}}>Dépenses</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {payments && payments.map(pay => (
                                    pay.type !== "aReturn" ? 
                                    (<TableRow
                                        hover
                                        className="clickable" 
                                        key={pay.payment_info_id} 
                                        onClick={ () => this.setState({ 
                                            openSpending: true, 
                                            spending: pay.spending 
                                        }) }
                                    >
                                        <TableCell>
                                            {new Date(pay.spending.spending_date).toLocaleDateString("fr-FR")}
                                        </TableCell>
                                        <TableCell>
                                            <b>{pay.category.category_name}</b> - <i>{pay.categoryParent}</i>
                                        </TableCell>
                                        <TableCell><Currency value={pay.payment_amount} /></TableCell>
                                    </TableRow>)
                                    :
                                    (<TableRow
                                        hover
                                        // className="clickable" 
                                        style={{backgroundColor: "cornsilk"}}
                                        key={pay.payment_info_id} 
                                        // onClick={ () => this.setState({ 
                                        //     openSpending: true, 
                                        //     spending: pay.spending 
                                        // }) }
                                    >
                                        <TableCell>
                                            {new Date(pay.date).toLocaleDateString("fr-FR")}
                                        </TableCell>
                                        <TableCell>
                                            <b>Retour sur Avance</b>
                                        </TableCell>
                                        <TableCell><Currency value={pay.payment_amount} /></TableCell>
                                    </TableRow>)
                                ))
                            }

                        </TableBody>
                    </Table>
                    
                </DialogContent>
            </Dialog>
        );
    }
}

export default AdvanceDetails;